import { render, staticRenderFns } from "./AdminRequests.vue?vue&type=template&id=3ac18971"
import script from "./AdminRequests.vue?vue&type=script&lang=js"
export * from "./AdminRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports